export const getMainClassesIds = (userDetails) => {
    if (!userDetails)
        return [];
    if (userDetails.defaultSchool?.mainClasses?.length > 0)
        return userDetails.defaultSchool.mainClasses.map(mainClass => ({
            ...mainClass,
            schoolName: userDetails.defaultSchool.name,
        }));

    return [];
};

export const isElementaryMainClass = (mainClass) => {
    const grade = parseInt(mainClass?.class, 10);
    return !Number.isNaN(grade) && grade >= 1 && grade <= 6;
};

export const isElementarySchool = (userDetails) => {
    return userDetails?.defaultSchool?.toClass < 7 && userDetails?.defaultSchool?.fromClass < 7;
};

export const getMainClasses = (userDetails) => {
    return userDetails?.defaultSchool?.mainClasses || [];
};

export const canShowScheduleMiniWidget = (user) => {
    if (!window.config.whiteListMessages?.length) {
        return true;
    }
    return window.config.whiteListMessages.includes(user?.exidentifier);
};
